module.exports = __webpack_public_path__ + "static/img/277_TO8_2412_og.6d4b80b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/277_TO8_2412_og.jpg
// module id = 6C2Z
// module chunks = 0